import { type StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type MessageTab, MessageTabs } from '@repo/types/messages-tabs';

interface MessagesState {
    activeTab: MessageTab;
    mode: 'add' | 'edit';
    draftMessage: string;
    messageId: number | null;
}

interface MessagesActions {
    setActiveTab: (activeTab: MessageTab) => void;
    setMode: (mode: 'add' | 'edit') => void;
    setDraftMessage: (draftMessage: string) => void;
    setMessageId: (messageId: number | null) => void;
}

interface State extends MessagesState, MessagesActions {}

const storeName = 'messages-store';

const createMessageStore: StateCreator<State, [['zustand/devtools', never]], [], State> = (set) => ({
    activeTab: MessageTabs.TSP_CUST,
    mode: 'add',
    draftMessage: '',
    messageId: null,

    setActiveTab: (activeTab) => {
        set({ activeTab });
    },
    setMode: (mode) => {
        set({ mode });
    },
    setDraftMessage: (draftMessage) => {
        set({ draftMessage });
    },
    setMessageId: (messageId) => {
        set({ messageId });
    },
});

export const useMessagesStore = create<State>()(
    devtools(createMessageStore, {
        name: storeName,
    })
);
